"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var humanizeString = require("humanize-string");
var toastr = require("toastr");
var permissionKey = "frends_permissions";
var Utilities = (function () {
    function Utilities() {
    }
    Utilities.getAllUserPermissions = function () {
        function getCookies() {
            var cookies = {};
            for (var _i = 0, _a = document.cookie.split("; "); _i < _a.length; _i++) {
                var cookie = _a[_i];
                var _b = cookie.split("="), name_1 = _b[0], value = _b[1];
                cookies[name_1] = decodeURIComponent(value);
            }
            return cookies;
        }
        var permissionMap = getCookies()[permissionKey];
        return permissionMap ? JSON.parse(permissionMap) : {};
    };
    Utilities.getUserPermission = function (activity) {
        var allPermissions = this.getAllUserPermissions();
        return allPermissions[activity];
    };
    Utilities.humanizeLabel = function (str) {
        if (str) {
            return capitalizeLastWordIfId(humanizeString(str));
        }
        return str;
    };
    Utilities.postJson = function (url, content) {
        return Utilities.fetchBase(url, content, "POST");
    };
    Utilities.putJson = function (url, content) {
        return Utilities.fetchBase(url, content, "PUT");
    };
    Utilities.getFetch = function (url) {
        return fetch(url, {
            credentials: "same-origin",
            headers: { "X-Requested-With": "XMLHttpRequest" }
        }).then(Utilities.parseJsonResponse);
    };
    Utilities.deleteFetch = function (url) {
        return fetch(url, {
            method: "DELETE",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-XSRF-Token": Utilities.getXSRFVerificationToken()
            },
            credentials: "same-origin"
        });
    };
    Utilities.parseJsonResponse = function (response) {
        return response.text()
            .then(function (content) {
            if (!response.ok) {
                var errorContent = void 0;
                try {
                    var errorMsg_1 = JSON.parse(content);
                    if (errorMsg_1["modelState"]) {
                        errorContent = [].concat.apply([], Object.keys(errorMsg_1["modelState"]).map(function (key) { return errorMsg_1["modelState"][key]; })).join("<br/>");
                    }
                    else {
                        errorContent = errorMsg_1["exceptionMessage"] || errorMsg_1["message"] || errorMsg_1;
                    }
                }
                catch (e) {
                    errorContent = content;
                }
                return Promise.reject("Error (" + response.status + "): " + errorContent);
            }
            else {
                return Promise.resolve(Utilities.getPossibleJsonFromText(content));
            }
        });
    };
    Utilities.getErrorTitle = function (err) {
        return _.has(err, "message") ? err.message : "Error";
    };
    Utilities.getErrorText = function (err) {
        return _.has(err, "exceptionMessage") ? err.exceptionMessage : err;
    };
    Utilities.getStepIdFromParameterKey = function (loopParameters) {
        if (!loopParameters) {
            return null;
        }
        return loopParameters.map(function (parameter) { return parameter.key + parameter.value; }).join();
    };
    Utilities.getReferencePathFrom$ref = function ($ref) {
        return _.last($ref.split("/"));
    };
    Utilities.getLoopParameterDictionary = function (loopParameters) {
        var ret = {};
        if (!loopParameters) {
            return ret;
        }
        for (var _i = 0, loopParameters_1 = loopParameters; _i < loopParameters_1.length; _i++) {
            var l = loopParameters_1[_i];
            ret[l.key] = l.value;
        }
        return ret;
    };
    Utilities.toDetailedLocalTime = function (d) {
        if (d) {
            return moment.utc(d).local().format("YYYY-MM-DD HH:mm:ss");
        }
        else {
            return FRENDS.Localizations.Never;
        }
    };
    Utilities.getXSRFVerificationToken = function () {
        return document.getElementsByName("__RequestVerificationToken")[0].getAttribute("value");
    };
    Utilities.navigateTo = function (path) {
        var base = document.getElementsByTagName("base")[0].href;
        var newProcessUrl = base + path;
        setTimeout(function () { return window.location.href = newProcessUrl; }, 1000);
    };
    Utilities.toastSuccess = function (message, title, keepOpen, showCloseButton) {
        if (title === void 0) { title = ""; }
        if (keepOpen === void 0) { keepOpen = false; }
        if (showCloseButton === void 0) { showCloseButton = true; }
        toastr.success(message, title, { closeButton: showCloseButton, closeOnHover: false, preventDuplicates: true, timeOut: keepOpen ? 0 : 5000 });
    };
    Utilities.toastWarning = function (message, title, keepOpen, showCloseButton) {
        if (title === void 0) { title = FRENDS.Localizations.Warning; }
        if (keepOpen === void 0) { keepOpen = false; }
        if (showCloseButton === void 0) { showCloseButton = false; }
        toastr.warning(message, title, { closeButton: showCloseButton, closeOnHover: false, preventDuplicates: true, timeOut: keepOpen ? 0 : 5000 });
    };
    Utilities.toastError = function (message, title, keepOpen, showCloseButton) {
        if (title === void 0) { title = FRENDS.Localizations.Error; }
        if (keepOpen === void 0) { keepOpen = true; }
        if (showCloseButton === void 0) { showCloseButton = true; }
        if (typeof appInsights !== "undefined") {
            appInsights.trackException(message, "Toast", (_a = {}, _a["Toast"] = "error", _a), null, 2);
        }
        toastr.error(message, title, { closeButton: showCloseButton, closeOnHover: false, preventDuplicates: true, timeOut: keepOpen ? 0 : 5000 });
        var _a;
    };
    Utilities.fetchBase = function (url, content, method) {
        return fetch(url, {
            method: method,
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-XSRF-Token": Utilities.getXSRFVerificationToken(),
                "X-Requested-With": "XMLHttpRequest"
            },
            credentials: "same-origin",
            body: JSON.stringify(content)
        });
    };
    Utilities.getPossibleJsonFromText = function (text) {
        if (text.length > 0) {
            try {
                return JSON.parse(text);
            }
            catch (e) {
                console.debug("Response not valid json: " + text, e);
            }
        }
        return text;
    };
    return Utilities;
}());
exports.Utilities = Utilities;
function capitalizeLastWordIfId(s) {
    var n = s.split(" ");
    if (n[n.length - 1] === "id") {
        n[n.length - 1] = n[n.length - 1].toUpperCase();
    }
    return n.join(" ");
}
function printWarning(msg) {
    if (typeof console !== "undefined") {
        console.warn(msg);
    }
}
exports.printWarning = printWarning;
function printError(msg) {
    if (typeof console !== "undefined") {
        console.error(msg);
    }
}
exports.printError = printError;
function strEnum(o) {
    return o.reduce(function (res, key) {
        res[key] = key;
        return res;
    }, Object.create(null));
}
exports.strEnum = strEnum;
function openInNewTabClick(event) {
    if (event.button === 0 && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        event.preventDefault();
        return false;
    }
    return true;
}
exports.openInNewTabClick = openInNewTabClick;



//////////////////
// WEBPACK FOOTER
// ./Scripts/app/shared/utilities.ts
// module id = 13
// module chunks = 8